import { IconName } from '@infotech-soe/erp-ui-kit';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { Caption } from '../../../models/caption/Caption';
import { ConfirmationType } from '../../../models/confirmation/ConfirmationEntity';
import { ConfirmationMessageType } from '../../../services/commands/UserInteractor';
import { AppDispatch } from '../../../store';
import { AppState } from '../../../store/reducers/root';
import { getCatalogsStateEntity } from '../../../store/selectors/catalogs';
import { getDatasetCommands } from '../../../store/selectors/commands';
import {
  getFirstPendingCommandConfirmation,
  hasPendingCommandConfirmations,
} from '../../../store/selectors/confirmation';
import { getHierarchyStateEntity } from '../../../store/selectors/hierarchy';
import confirmationAction from '../../../store/slices/confirmation';
import { getCommand } from '../../components/dataset/utils/getCommand';
import CommandConfirmationDialog from '../../components/dialogs/CommandConfirmationDialog';
import { findNode } from '../../components/dm-tree/utils';

const mapStateToProps = (state: AppState) => {
  const confirmation = getFirstPendingCommandConfirmation(state);

  const getCommandCaption = (): Caption | undefined => {
    if (confirmation?.type === ConfirmationType.DATASET) {
      const datasetCommands = getDatasetCommands(state, confirmation.dataset);
      return getCommand(confirmation.action.command, datasetCommands)?.caption;
    }
  };

  const moveInArgs =
    (confirmation?.type === ConfirmationType.CATALOGS ||
      confirmation?.type === ConfirmationType.HIERARCHY) &&
    (confirmation.messageType === ConfirmationMessageType.MOVE_IN_CATALOG ||
      confirmation.messageType === ConfirmationMessageType.MOVE_HIERARCHY)
      ? confirmation.action.args
      : undefined;
  const moveInTree = moveInArgs
    ? confirmation?.type === ConfirmationType.HIERARCHY
      ? getHierarchyStateEntity(state, moveInArgs.treeId)
      : getCatalogsStateEntity(state, moveInArgs.treeId)
    : undefined;

  return {
    type: confirmation?.type ?? ConfirmationType.DATASET,
    dataset:
      confirmation?.type === ConfirmationType.DATASET
        ? confirmation.dataset
        : undefined,
    open: hasPendingCommandConfirmations(state),
    messageType: confirmation
      ? confirmation.messageType
      : ConfirmationMessageType.GENERIC,
    shortMessage: confirmation?.shortMessage,
    longMessage: confirmation?.longMessage,
    icon: confirmation?.icon as IconName,
    commandCaption: getCommandCaption(),
    moveInCount: Array.isArray(moveInArgs?.nodeId)
      ? moveInArgs.nodeId.length
      : undefined,
    moveInNodeName: moveInTree
      ? findNode(moveInTree.nodes, moveInArgs.parentId)?.label
      : undefined,
    renameName:
      confirmation?.type === ConfirmationType.CATALOGS &&
      confirmation.messageType === ConfirmationMessageType.RENAME_CATALOG
        ? confirmation.action.args.name
        : undefined,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onConfirm: (command: ConfirmationMessageType, answer?: string) => {
    command.includes('Catalog') || command.includes('Hierarchy')
      ? dispatch(confirmationAction.approveCatalogs({ answer }))
      : dispatch(confirmationAction.approve());
  },
  onCancel: () => dispatch(confirmationAction.close()),
});
const connector = connect(mapStateToProps, mapDispatchToProps);

export type CommandConfirmationDialogProps = ConnectedProps<typeof connector>;

export default connector(CommandConfirmationDialog);
